// extracted by mini-css-extract-plugin
export default {"container":"container___Bls6e","text":"text___cGbml"};